export enum AudioBridgeEvent {
    SUCCESS = 'success',
    ERROR = 'error',
    CONSENT_DIALOG = 'consentDialog',
    ICE_STATE = 'iceState',
    MEDIA_STATE = 'mediaState',
    WEBRTC_STATE = 'webrtcState',

    JOINED = 'joined',
    ROOM_CHANGED = 'roomchanged',
    DESTROYED = 'destroyed',

    PARTICIPANTS = 'participants',
    ERROR_EVENT = 'error_event',
    LEAVING = 'leaving',

    ON_REMOTE_STREAM = 'onremotestream',
    ON_CLEAN_UP = 'oncleanup',

    TALKING = 'talking',
    STOPPED_TALKING = 'stopped-talking',

    SET = 'set',
}